export { default as SocialMediaIcons } from 'components/common/socialMedia/icons';
